<template>
  <Layout
    username="Agent"
    current-page="Record Sale"
    link-to-edit="/agent-dashboard/edit-profile"
  >
    <template slot="menuItems">
      <li
        v-for="{ title, icon, path } in menu"
        :key="title"
        class="nav-item"
      >
        <MenuItems
          :menu-item="title"
          :icon-menu="icon"
          :to-where="path"
        />
      </li>
    </template>
    <template slot="side info">
      <router-link
        class="side-info"
        to="/agent/sales"
      >
        View records
      </router-link>
    </template>
    <template slot="content">
      <div
        class="jumbotron justify-content-center d-sm-none d-md-block col-md-10"
      >
        <ValidationObserver v-slot="{ invalid }">
          <form>
            <div class="form-row">
              <ValidationProvider
                v-slot="{ errors }"
                rule="required"
                mode="aggressive"
                rules="required"
                class="col-md-6 col-sm-12"
                persist
              >
                <div class="form-group">
                  <label for="inputName">Client's Name</label>
                  <input
                    v-model="newRecord.clientName"
                    name="client's name"
                    type="text"
                    placeholder="John Doe"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    required
                  >
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-row">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|digits:16"
                mode="aggressive"
                class="col-md-6"
                persist
              >
                <div class="form-group">
                  <label for="ID card">ID card</label>
                  <input
                    v-model="newRecord.clientID"
                    name="ID card"
                    type="text"
                    placeholder="1 1999 99999999 999"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                  >
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|phone|digits:10"
                mode="aggressive"
                class="col-md-6"
                persist
              >
                <div class="form-group">
                  <label for="phone number">Phone</label>
                  <input
                    v-model="newRecord.phoneNumber"
                    name="phone number"
                    type="text"
                    placeholder="0788888888"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    required
                  >
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-row">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|digits:2|age"
                mode="aggressive"
                class="col-md-6"
                persist
              >
                <div class="form-group">
                  <label for="age">Age</label>
                  <input
                    v-model="newRecord.age"
                    name="age"
                    type="text"
                    placeholder="20"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                  >
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                mode="aggressive"
                class="col-md-6"
                persist
              >
                <div class="form-group">
                  <label for="gender">Gender</label>
                  <select
                    v-model="newRecord.sex"
                    name="gender"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                  >
                    <option value="">
                      Choose...
                    </option>
                    <option value="male">
                      Male
                    </option>
                    <option value="female">
                      Female
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-row">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                mode="aggressive"
                class="col-md-2"
                persist
              >
                <div class="form-group">
                  <label for="province">Province</label>
                  <select
                    v-model="newRecord.province"
                    name="province"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    required
                    @change="setDistricts"
                  >
                    <option value="">
                      Choose...
                    </option>
                    <option
                      v-for="province in provinces"
                      :key="province"
                      :value="province"
                    >
                      {{ province }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                mode="aggressive"
                class="col-md-2"
                persist
              >
                <div class="form-group col-lg">
                  <label for="district">District</label>
                  <select
                    v-model="newRecord.district"
                    name="district"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    required
                    @change="setSectors"
                  >
                    <option value="">
                      Choose...
                    </option>
                    <option
                      v-for="district in districts"
                      :key="district"
                      :value="district"
                    >
                      {{ district }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                mode="aggressive"
                class="col-md-2"
                persist
              >
                <div class="form-group col-lg">
                  <label for="sector">Sector</label>
                  <select
                    v-model="newRecord.sector"
                    name="sector"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    required
                    @change="setCells"
                  >
                    <option value="">
                      Choose...
                    </option>
                    <option
                      v-for="sector in sectors"
                      :key="sector"
                    >
                      {{ sector }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                mode="aggressive"
                class="col-md-2"
                persist
              >
                <div class="form-group col-lg">
                  <label for="cell">Cell</label>
                  <select
                    v-model="newRecord.cell"
                    name="cell"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    required
                    @change="setVillages"
                  >
                    <option value="">
                      Choose...
                    </option>
                    <option
                      v-for="cell in cells"
                      :key="cell"
                    >
                      {{ cell }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                mode="aggressive"
                class="col-md-2"
                persist
              >
                <div class="form-group col-lg">
                  <label for="village">Village</label>
                  <select
                    v-model="newRecord.village"
                    name="village"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    required
                  >
                    <option value="">
                      Choose...
                    </option>
                    <option
                      v-for="village in villages"
                      :key="village"
                    >
                      {{ village }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div>
              <div
                v-for="(i, index) in newRecord.items"
                :key="index"
                class="item"
              >
                <p class="h6 text-center">
                  Item {{ index + 1 }}
                </p>

                <div class="form-row">
                  <div class="col-md-4">
                    <label for="item-name">Name</label>
                    <input
                      id="item-name"
                      v-model="newRecord.items[index].name"
                      type="text"
                      class="form-control mb-2"
                      placeholder="Solar Panel XY7"
                    >
                  </div>
                  <div class="col-md-4">
                    <label for="inlineFormInputGroup">Price</label>
                    <div class="input-group mb-2">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          Rwf
                        </div>
                      </div>
                      <input
                        id="inlineFormInputGroup"
                        v-model="newRecord.items[index].price"
                        type="text"
                        class="form-control"
                        placeholder="Price"
                      >
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label for="inlineFormInputGroup">Quantity</label>
                    <div class="input-group mb-2">
                      <input
                        id="inlineFormInputGroup"
                        v-model="newRecord.items[index].quantity"
                        type="number"
                        class="form-control"
                        placeholder="Quantity"
                      >
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="item-description">Item Description</label>
                  <textarea
                    id="item-description"
                    v-model="newRecord.items[index].description"
                    class="form-control"
                    rows="3"
                  />
                </div>
              </div>
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                @click="addItem"
              >
                Add Item
              </button>
            </div>
            <div class="d-flex flex-row-reverse mt-4">
              <primary-button
                title="Save Draft"
                classes="btn btn-secondary p2 ml-2"
                :loading="isSubmitting"
                :disabled="invalid"
                @click.native.prevent="onSubmit(true)"
              />
              <primary-button
                title="Record Sale"
                classes="btn btn-primary p2"
                :loading="isSubmitting"
                :disabled="invalid"
                @click.native.prevent="onSubmit(false)"
              />
            </div>
          </form>
        </ValidationObserver>
      </div>
    </template>
  </Layout>
</template>

<script>
import { mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { Provinces, Districts, Sectors, Cells, Villages } from "rwanda";
import Layout from "../../components/Layout";
import MenuItems from "../../components/MenuItems";
import PrimaryButton from "../../components/Buttons/PrimaryButton.vue";
export default {
  name: "Recordsale",
  components: {
    Layout,
    MenuItems,
    PrimaryButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      menu: [
        {
          title: "Record Sale",
          icon: "fa fa-cash-register",
          path: "/agent",
        },
        {
          title: "Drafted Records",
          icon: "fa fa-edit",
          path: "/agent/drafts",
        },
        {
          title: "View Sales",
          icon: "fa fa-table",
          path: "/agent/sales",
        },
      ],
      itemProps: {
        name: "",
        price: null,
        quantity: null,
      },
      provinces: Provinces(),
      districts: [],
      sectors: [],
      cells: [],
      villages: [],
      newRecord: {
        province: "",
        district: "",
        sector: "",
        cell: "",
        village: "",
        clientName: "",
        clientID: "",
        phoneNumber: "",
        age: "",
        sex: "",
        items: [
          {
            name: null,
            price: null,
            quantity: null,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      isSubmitting: "sales/isSubmitting",
    }),
  },
  methods: {
    setDistricts(e) {
      this.districts = Districts(e.target.value);
      this.newRecord.district = "";
    },
    setSectors(e) {
      this.sectors = Sectors(this.newRecord.province, e.target.value);
      this.newRecord.sector = "";
    },
    setCells(e) {
      this.cells = Cells(
        this.newRecord.province,
        this.newRecord.district,
        e.target.value
      );
      this.newRecord.cell = "";
    },
    setVillages() {
      this.villages = Villages(
        this.newRecord.province,
        this.newRecord.district,
        this.newRecord.sector,
        this.newRecord.cell
      );
      this.newRecord.village = "";
    },
    onSubmit(editable) {
      this.$store
        .dispatch("sales/saveRecord", {
          ...this.newRecord,
          editable,
        })
        .then((data) => {
          if (data.editable) {
            return this.$router.push("/agent/drafts");
          }
          return this.$router.push("/agent/sales");
        })
        .catch(() => {
          // console.log(err.response);
        });
    },
    addItem() {
      this.newRecord.items = [...this.newRecord.items, { ...this.itemProps }];
    },
  },
};
</script>

<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}

.jumbotron {
  overflow-x: scroll;
}
.side-info {
  color: #8bc34a;
}

.side-info:hover {
  color: #5a9216;
}
.icon {
  width: 15px;
  height: 15px;
}
</style>
